export default __webpack_public_path__ + "static/media/star-editions.a12def30.png";